import http from "infra/http";
import { useQuery } from "react-query";
import { MinhaFormaPagamentoResponse } from "../typings";

function useMinhasFormaPagamentos(tenantId: string, ativo?: "1" | "0") {
  return useQuery([`/v1/forma-pagamento/minhas`], async () => {
    const { data } = await http.get<MinhaFormaPagamentoResponse[]>(
      `/v1/forma-pagamento/minhas`,
      {
        params: { ativo },
        headers: {
          tenant: tenantId,
        },
      }
    );

    return data;
  });
}

export default useMinhasFormaPagamentos;
